import React from "react"
import { Box } from "@mui/material"
import Button from "components/Buttons/Button"

import useToggle from "@secureo/common/hooks/useToggle"
import { useTranslation } from "react-i18next"

import { LockingSystemReducerState } from "reducers/lockingSystemReducer"

import Icon from "@mdi/react"
import {
	mdiPencil,
	mdiCheckboxMarkedCircleOutline,
	mdiCheckboxBlankOutline,
	mdiChevronDown,
	mdiChevronUp,
} from "@mdi/js"

const MiniMatrix = ({
	matrix,
	componentsByUuid,
	lockingComponentsUuids,
	keyComponentsUuids,
	matrixType,
	setEditComponentModalUuid,
}: Props) => {
	const [showMiniMatrix, toggleShowMiniMatrix] = useToggle()
	const { t } = useTranslation("lockingSystem")
	return (
		<div>
			<Box
				my={2}
				p={1}
				style={{
					background: "white",
					boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.15)",
					borderRadius: 5,
				}}
			>
				<div style={{ display: "flex", justifyContent: "space-between" }}>
					<div style={{ display: "flex" }}>
						<div
							style={{
								background: "rgba(70, 145, 206, 0.2)",
								height: 40,
								padding: 6,
								paddingTop: 7,
								borderRadius: 3,
								marginRight: 8,
							}}
						>
							<Icon path={mdiPencil} size={1} color="#4691CE" />
						</div>
						<div>
							<strong>Schließplan</strong>
							<div>{matrixType ? t(matrixType) : "System"}</div>
						</div>
					</div>
					<Button
						onClick={toggleShowMiniMatrix}
						style={{ maxWidth: 140, height: 40 }}
						size="small"
					>
						{!showMiniMatrix ? "Anzeigen" : "Verbergen"}{" "}
						<Icon path={!showMiniMatrix ? mdiChevronDown : mdiChevronUp} size={1} />
					</Button>
				</div>
				{showMiniMatrix && (
					<table
						style={{
							padding: 10,
							marginTop: 10,
						}}
					>
						<thead>
							<th></th>
							<th></th>
							{keyComponentsUuids.map((uuid, index) => {
								const { name } = componentsByUuid[uuid]

								return <th key={uuid}>{name || `Gruppe ${index + 1}`}</th>
							})}
						</thead>
						<tbody>
							{lockingComponentsUuids.map((uuid, rowIndex) => {
								const { name } = componentsByUuid[uuid]

								return (
									<tr key={uuid}>
										<td>
											<button
												style={{
													background: "rgba(70, 145, 206, 0.25)",
													width: 40,
													height: 40,
													borderRadius: 3,
													textAlign: "center",
													border: "none",
													outline: "none",
													cursor: "pointer",
													marginLeft: 4,
													marginRight: 10,
												}}
												disabled={!setEditComponentModalUuid}
												onClick={() => {
													setEditComponentModalUuid(uuid)
												}}
											>
												<Icon path={mdiPencil} size={1} color="#4691CE" />
											</button>
										</td>
										<td>{name || `Zylinder ${rowIndex + 1}`}</td>
										{matrix[rowIndex].map((isSelected, columnIndex) => {
											return (
												<td
													key={`${uuid}-${columnIndex}`}
													style={{ textAlign: "center" }}
												>
													<Icon
														path={
															isSelected
																? mdiCheckboxMarkedCircleOutline
																: mdiCheckboxBlankOutline
														}
														size={1}
													/>
												</td>
											)
										})}
									</tr>
								)
							})}
						</tbody>
					</table>
				)}
			</Box>
		</div>
	)
}

interface Props {
	matrix: boolean[][]
	setEditComponentModalUuid?: (uuid: string) => void
	componentsByUuid: LockingSystemReducerState["componentsByUuid"]
	matrixType: LockingSystemReducerState["matrixType"]
	lockingComponentsUuids: LockingSystemReducerState["lockingComponentsUuids"]
	keyComponentsUuids: LockingSystemReducerState["keyComponentsUuids"]
}

export default MiniMatrix
